import axios from 'axios'

import { API_BASE, apiErrorHandler } from '../api'
import Auth from '../auth'

const ENDPOINT = `${API_BASE}org-chart/`
const EXPENSES = `${ENDPOINT}expenses/`
const DECLINES = `${ENDPOINT}decline_reasons/`
const EVENTS = `${ENDPOINT}events/`
const METRIC_CHART_DATA = `${ENDPOINT}metric_data/`

export default class OrgChartAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new OrgChartAPI(cls)
  }

  events(organizationId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(filter)
    }

    const promise = axios
      .get(`${EVENTS}${organizationId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'OrganizationChartAPI.events' }))
    return promise
  }

  expenses(organizationId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(filter)
    }

    const promise = axios
      .get(`${EXPENSES}${organizationId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'OrganizationChartAPI.expenses' }))
    return promise
  }

  declines(organizationId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .get(`${DECLINES}${organizationId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'OrganizationChartAPI.declines' }))
    return promise
  }

  metricChartData(organizationId, metric, timeframe, dateInformation = {}) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const dateInformationParams = new URLSearchParams(dateInformation).toString()
    const promise = axios
      .get(
        `${METRIC_CHART_DATA}${organizationId}/?metric=${metric}&timeframe=${timeframe}&${dateInformationParams}`,
        options,
      )
      .then(res => res.data)
      .catch(apiErrorHandler({ apiName: 'OrganizationChartAPI.declines' }))
    return promise
  }

  buildFilter(filter) {
    return filter ? Object.assign({}, {
      // Send the dates in YYYY-MM-DD format with no timezone
      startDate: filter.startDate.toISOString().split("T")[0],
      endDate: filter.endDate.toISOString().split("T")[0]
    })
    : null;
  }
}
